import { render } from "./VPAAUploadedCompliances.vue?vue&type=template&id=987f5110"
import script from "./VPAAUploadedCompliances.vue?vue&type=script&lang=js"
export * from "./VPAAUploadedCompliances.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__